import { render } from "./contestDetail.vue?vue&type=template&id=148badec&scoped=true"
import script from "./contestDetail.vue?vue&type=script&lang=js"
export * from "./contestDetail.vue?vue&type=script&lang=js"

import "./contestDetail.vue?vue&type=style&index=0&id=148badec&lang=less&scoped=true"

import exportComponent from "D:\\benq\\dev-front\\design-competition\\2021\\design-competition-web-pc\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-148badec"]])

export default __exports__